module.exports = __webpack_public_path__ + "static/media/france_sud.ecec7c70.svg";